export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";